import script from "./Password.vue?vue&type=script&setup=true&lang=js"
export * from "./Password.vue?vue&type=script&setup=true&lang=js"

import "./Password.vue?vue&type=style&index=0&id=f2b90f98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2b90f98"]])

export default __exports__